export function buildPersonPath(isNavigationRedesign: boolean, personId: string, subpath?: string) {
    const base = isNavigationRedesign ? `/org/employees/${personId}` : `/people/${personId}`;

    return subpath ? `${base}/${subpath}` : base;
}
